import styled from 'styled-components';

import { DisplayRightIcon } from '@genially/icons';

export const StyledDisplayRightIcon = styled(DisplayRightIcon)(
  ({ theme: { color } }) => ({
    color: color.content.secondary.default(),
    flexShrink: 0,
  }),
);

export const RightIconWrapper = styled.div(({ theme: { size } }) => ({
  padding: `0 ${size.units(0.5)}`,
}));

export const Wrapper = styled.div(() => ({
  minWidth: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}));
